function changeDisabled(){
  optin = document.getElementById('optin');
  if(optin.checked) {
    document.getElementById('checkout_btn').disabled = "";
  } else {
    document.getElementById('checkout_btn').disabled = "disabled";
  }
}

function toFullWidthKatakana(str) {
    return str.replace(/[\u3041-\u3096]/g, function(match) {
        // ひらがなを全角カタカナに変換
        return String.fromCharCode(match.charCodeAt(0) + 0x60);
    });
}

function convertToKatakana() {
    const inputField = document.getElementsByClassName('kana_chenge');
    const inputValue = inputField.value;
    const convertedValue = toFullWidthKatakana(inputValue);
    inputField.value = convertedValue;
}

/* match Height 
------------------------------------- */
$(function() {
    $('.js-matchHeight').matchHeight();
  });

/* ranking 高さを低い方にそろえる 
------------------------------------- */
document.addEventListener('DOMContentLoaded', function() {
  const customRanking = document.querySelector('.custom-ranking');
  
  if (customRanking) {
    const imageAnimate = customRanking.querySelector('.card--image-animate');
    
    if (imageAnimate) {
      function updateHeights() {
        const imageHeight = imageAnimate.offsetHeight;
        const heightSettings = customRanking.querySelectorAll('.js-height-setting');
        
        heightSettings.forEach(function(element) {
          element.style.height = `${imageHeight}px`;
        });
      }

      // 初回実行
      updateHeights();

      // ResizeObserverを使用して.card--image-animateのサイズ変更を監視
      const resizeObserver = new ResizeObserver(updateHeights);
      resizeObserver.observe(imageAnimate);

      // ウィンドウのリサイズイベントにも対応
      window.addEventListener('resize', updateHeights);
    }
  }
});

/* feed In 
------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  const blocks = document.querySelectorAll('.custom-panel-grid');

  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };

  const fadeInObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const block = entry.target;
        const fadeElements = block.querySelectorAll('.fade-in');
        const maxOrder = Math.max(...Array.from(fadeElements).map(el => 
          parseInt(el.className.match(/js-feed-in-order-(\d+)/)[1] || '0')
        ));

        for (let i = 1; i <= maxOrder; i++) {
          const element = block.querySelector(`.js-feed-in-order-${i}`);
          if (element) {
            setTimeout(() => {
              element.classList.add('active');
            }, i * 500);
          }
        }

        observer.unobserve(block);
      }
    });
  }, observerOptions);

  blocks.forEach(block => {
    fadeInObserver.observe(block);
  });
});

/* Grid
------------------------------------- */
let msnryPCs = [], msnrySPs = [];

document.addEventListener('DOMContentLoaded', () => {
  const gridsPC = document.querySelectorAll('.js-custom-grid_pc');
  const gridsSP = document.querySelectorAll('.js-custom-grid_sp');

  // 初期表示：アスペクト比に合わせて表示
  gridsPC.forEach(setInitialHeights);
  gridsSP.forEach(setInitialHeights);

  // 画像の読み込みを待ってからMasonryを初期化
  gridsPC.forEach(grid => {
    imagesLoaded(grid, () => {
      initMasonry(grid, 'PC');
    });
  });

  gridsSP.forEach(grid => {
    imagesLoaded(grid, () => {
      initMasonry(grid, 'SP');
    });
  });
});

function initMasonry(grid, type) {
  const msnry = new Masonry(grid, {
    itemSelector: '.js-custom-grid-item',
    columnWidth: '.js-colmun',
    gutter: '.js-gutter-sizer',
    percentPosition: true,
    transitionDuration: 0 // アニメーションを無効化
  });

  if (type === 'PC') {
    msnryPCs.push(msnry);
  } else {
    msnrySPs.push(msnry);
  }

  // Masonryのレイアウト完了後に高さ調整を実行
  msnry.on('layoutComplete', () => {
    setTimeout(() => {
      adjustHeights(grid);
      removeTransforms(grid);
      msnry.layout();
    }, 100);
  });

  // 初回レイアウト
  msnry.layout();
}

function setInitialHeights(grid) {
  const items = grid.querySelectorAll('.js-custom-grid-item');
  items.forEach(item => {
    const link = item.querySelector('.js-custom-gird-item-link');
    if (link) {
      const ratio = link.getAttribute('data-aspect-ratio');
      if (ratio) {
        const [width, height] = ratio.split('/').map(Number);
        const itemWidth = item.offsetWidth;
        const calculatedHeight = (itemWidth / width) * height;
        item.style.height = `${calculatedHeight}px`;
        link.style.height = `${calculatedHeight}px`;
      }
    }
  });
}

function adjustHeights(grid) {
  const items = grid.querySelectorAll('.js-custom-grid-item');
  const itemData = Array.from(items).map(item => ({
    item,
    top: parseFloat(item.style.top),
    height: item.offsetHeight,
    get totalHeight() { return this.top + this.height; }
  }));

  // 合計高さが近いアイテムの調整
  adjustTotalHeights(itemData);
}

function adjustTotalHeights(itemData) {
  const threshold = 30; // 合計値の差の閾値
  let adjustmentMade;

  do {
    adjustmentMade = false;
    for (let i = 0; i < itemData.length; i++) {
      for (let j = i + 1; j < itemData.length; j++) {
        const diff = Math.abs(itemData[i].totalHeight - itemData[j].totalHeight);
        if (diff <= threshold && diff > 0) {
          const minTotalHeight = Math.min(itemData[i].totalHeight, itemData[j].totalHeight);
          [itemData[i], itemData[j]].forEach(data => {
            if (data.totalHeight > minTotalHeight) {
              const newHeight = minTotalHeight - data.top;
              if (newHeight > 0 && newHeight !== data.height) {
                data.item.style.height = `${newHeight}px`;
                const link = data.item.querySelector('.js-custom-gird-item-link');
                if (link) {
                  link.style.height = `${newHeight}px`;
                }
                data.height = newHeight;
                adjustmentMade = true;
              }
            }
          });
        }
      }
    }
  } while (adjustmentMade);
}

function removeTransforms(grid) {
  const items = grid.querySelectorAll('.js-custom-grid-item');
  items.forEach(item => {
    item.style.transform = '';
    item.style.transition = '';
  });
}

// ウィンドウリサイズ時の処理
window.addEventListener('resize', debounce(() => {
  const gridsPC = document.querySelectorAll('.js-custom-grid_pc');
  const gridsSP = document.querySelectorAll('.js-custom-grid_sp');

  msnryPCs.forEach((msnry, index) => {
    const grid = gridsPC[index];
    setInitialHeights(grid);
    msnry.layout();
    setTimeout(() => {
      adjustHeights(grid);
      removeTransforms(grid);
      msnry.layout();
    }, 100);
  });

  msnrySPs.forEach((msnry, index) => {
    const grid = gridsSP[index];
    setInitialHeights(grid);
    msnry.layout();
    setTimeout(() => {
      adjustHeights(grid);
      removeTransforms(grid);
      msnry.layout();
    }, 100);
  });
}, 250));

// デバウンス関数は変更なし
/*
function adjustPanelHeights() {
  const panels = document.querySelectorAll('.js-custom-gird-item-link');
  
  panels.forEach(panel => {
    const aspectRatio = panel.dataset.aspectRatio.split('/');
    const widthRatio = parseFloat(aspectRatio[0]);
    const heightRatio = parseFloat(aspectRatio[1]);
    
    const width = panel.offsetWidth;
    const height = (width * heightRatio) / widthRatio;
    
    panel.style.height = `${height}px`;
  });
}

// ウィンドウのリサイズ時に高さを調整
window.addEventListener('resize', adjustPanelHeights);

// 初期ロード時に高さを調整
document.addEventListener('DOMContentLoaded', adjustPanelHeights);
*/